const CENSUS_TITLE = "Census & current information";

const BACK_TO_APP_HOME = "Back to Application Home";

const CURRENT_HEALTH_INSURANCE = {
  TITLE: "Current health insurance",
};

const STEPS_WITH_COBRA = [
  { label: "Current team" },
  { label: "Current health insurance" },
  { label: "COBRA participants" },
];

const STEPS_WITHOUT_COBRA = [
  { label: "Current team" },
  { label: "Current health insurance" },
];

const COBRA_CENSUS_CONTENTS = {
  pageTitle: "COBRA participants",
  introduction:
    "Please add all former employees and their dependents currently on COBRA. Some healthcare providers have restrictions based on the percentage of applicants on COBRA.",
  backButtonText: "Back",
  nextButtonText: "Save & continue",
};

const BACK_BUTTON_TEXT = "Back";
const NEXT_BUTTON_TEXT = "Save & continue";
const LOADING_BUTTON_TEXT = "Loading";

const CURRENT_EMPLOYEES_FORM_TITLE = "Company staff & dependents";
const CURRENT_EMPLOYEES_DRAWER_FORM_TITLE =
  "To get an accurate quote, we need everyone who is eligible for benefits";

export {
  CENSUS_TITLE,
  COBRA_CENSUS_CONTENTS,
  BACK_TO_APP_HOME,
  STEPS_WITH_COBRA,
  STEPS_WITHOUT_COBRA,
  BACK_BUTTON_TEXT,
  NEXT_BUTTON_TEXT,
  LOADING_BUTTON_TEXT,
  CURRENT_EMPLOYEES_FORM_TITLE,
  CURRENT_EMPLOYEES_DRAWER_FORM_TITLE,
  CURRENT_HEALTH_INSURANCE,
};
